<app-header>Loading...</app-header>
  <div class="container general">
    <div class="row row-offcanvas row-offcanvas-left active">
      <div class="col-3 transition sidebar-offcanvas" id="">
        <app-left-menu>Loading...</app-left-menu>
      </div><!--/span-->
      <div class="col-9 transition sidebar-offcanvas-right">
        <router-outlet></router-outlet>
      </div><!--/span-->
    </div><!--/row-->
</div><!--/.container-->

<app-error-modal></app-error-modal>
